export const InteractiveCategoryList =
{
    activeForAll: false,
    enableFilterByShowInHome: false

}
export const collectionList =
{
    default: true,
    contactUrl: false //list collections header custom bfs
}

export const showContactLink = true;

export const showSubCategoryDescription = false; // if true, the subcategory description will display in the IVL


export const addCalloutOption =
{
    enabled: false,
    title: "Callout"
};